import { Input } from "antd";
import { useState } from "react";

const PlainSearch = ({
  placeholder,
  filters,
  setFilters,
  entity,
  style,
  className,
}) => {
  const [query, setQuery] = useState("");
  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };
  const handleInputEnter = () => {
    setFilters({ ...filters, [`${entity}`]: query });
  };
  return (
    <div className={className}>
      <Input
        placeholder={placeholder}
        style={style ? style : { height: "40px" }}
        onPressEnter={handleInputEnter}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default PlainSearch;
